import type { TotpFactor } from "@/auth/mfaFactors";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";

interface FactorPickerProps {
  factors: TotpFactor[];
  value: string;
  onChange: (factorId: string) => void;
}

export const FactorPicker = ({ factors, value, onChange }: FactorPickerProps) => {
  if (factors.length < 2) return null;

  return (
    <RadioGroup aria-label="Which device?" value={value} onValueChange={onChange}>
      {factors.map((factor) => (
        <div key={factor.id} className="flex items-center space-x-2">
          <RadioGroupItem value={factor.id} id={`mfa-factor-${factor.id}`} />
          <Label htmlFor={`mfa-factor-${factor.id}`}>{factor.friendlyName}</Label>
        </div>
      ))}
    </RadioGroup>
  );
};
